var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsGenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4118 6.1V3.88C10.4118 2.87191 10.4118 2.36786 10.2194 1.98282C10.0502 1.64413 9.78027 1.36876 9.44822 1.19619C9.07073 1 8.57656 1 7.58824 1H3.82353C2.8352 1 2.34104 1 1.96355 1.19619C1.6315 1.36876 1.36153 1.64413 1.19234 1.98282C1 2.36786 1 2.87191 1 3.88V10.12C1 11.1281 1 11.6321 1.19234 12.0172C1.36153 12.3559 1.6315 12.6312 1.96355 12.8038C2.34104 13 2.8352 13 3.82353 13H5.70588M9.23529 12.4V8.8M7.47059 10.6H11",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsGenerate);
export default __webpack_public_path__ + "static/media/reports-generate.3219a1c8c3f7cc66dd30e00bea4d2664.svg";
export { ForwardRef as ReactComponent };